import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import {
  SuomifiThemeProvider,
  defaultSuomifiTheme,
} from "suomifi-ui-components";
import { AppProvider } from "./state/store";
import AppShell from "./layout/AppShell";
import ScrollToTop from "./layout/ScrollToTop";
import Etusivu from "./views/Etusivu";
import TukipyyntoLista from "./views/TukipyyntoLista";
import TukipyyntoNakyma from "./views/TukipyyntoNakyma";
import KayttajaKortti from "./views/KayttajaKortti";
import KayttajanTodennusyritykset from "./views/KayttajanTodennusyritykset";
import KayttajaHaku from "./views/KayttajaHaku";
import Kayttooikeudet from "./views/Kayttooikeudet";
import KayttooikeusKortti from "./views/KayttooikeusKortti";
import VirkailijanLisays from "./views/VirkailijanLisays";
import { useAuth } from "./useAuth";
import { useGetCurrentUserQuery } from "./api/backendApi";

/* Raportit-route on lazy-loadattu, koska se on ainoa sivu joka tuo Rechartsin
   (~80-100 kB gzip). Tällä initial bundle pysyy kevyenä — Recharts ladataan
   vasta kun käyttäjä menee /raportit-reitille. */
const Viikkoraportti = lazy(() => import("./views/Viikkoraportti"));

export default function App() {
  // Init authentication
  const { loading, user } = useAuth();
  const { data, isLoading, error } = useGetCurrentUserQuery();

  if (loading) {
    return <>Loading...</>;
  }
  if (!user) {
    return null; // Browser is already being redirected
  }

  // Test authentication with a dummy call
  if (error) {
    console.error("Authentication test failed:", error);
  }
  /*if (data) {
    console.log(data);
  }*/

  return (
    <SuomifiThemeProvider theme={defaultSuomifiTheme}>
      <ThemeProvider theme={defaultSuomifiTheme}>
        <AppProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppShell>
              <Routes>
                <Route path="/" element={<Etusivu />} />
                <Route path="/tukipyynnot" element={<TukipyyntoLista />} />
                <Route path="/tukipyynnot/:id" element={<TukipyyntoNakyma />} />
                <Route path="/kayttajahaku" element={<KayttajaHaku />} />
                <Route
                  path="/raportit"
                  element={
                    <Suspense fallback={null}>
                      <Viikkoraportti />
                    </Suspense>
                  }
                />
                <Route path="/kayttajat/:uid" element={<KayttajaKortti />} />
                <Route
                  path="/kayttajat/:uid/todennusyritykset"
                  element={<KayttajanTodennusyritykset />}
                />
                <Route path="/kayttooikeudet" element={<Kayttooikeudet />} />
                <Route
                  path="/kayttooikeudet/lisaa"
                  element={<VirkailijanLisays />}
                />
                <Route
                  path="/kayttooikeudet/:uid"
                  element={<KayttooikeusKortti />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppShell>
          </BrowserRouter>
        </AppProvider>
      </ThemeProvider>
    </SuomifiThemeProvider>
  );
}
